import React, { memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { GSIcon } from 'src/components/shared/GSIcon'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { InternalPermission } from 'src/constants/internal-access/internalPermissions'
import { useHasPermission } from 'src/hooks/useHasPermission'

interface Props {
  searchQuery: string
  onSearchQueryChange(query: string): void
  onRefresh(): void
  onInviteClick(): void
}

/** The table card's white header, as on `GigsafeUsersTableToolbar`. Search filters in memory. */
const InternalUsersToolbarComponent = ({
  searchQuery,
  onSearchQueryChange,
  onRefresh,
  onInviteClick,
}: Props) => {
  const canManage = useHasPermission(InternalPermission.InternalUsersManage)

  return (
    <div
      css={tw`flex flex-row items-center gap-4 rounded-t-lg border-0 border-b border-t border-solid border-shades-100 bg-shades-0 px-4 py-3`}
    >
      <TableSearch
        searchQuery={searchQuery}
        onChangeSearchQuery={onSearchQueryChange}
        width={320}
        debounceMs={150}
        inputDataTestId="internal-users-search-input"
      />
      <div css={tw`ml-auto flex flex-row items-center gap-2`}>
        <Button
          size="small"
          color="white"
          leftIcon={<GSIcon iconName="gs_arrows_repeat" size={20} css={tw`text-shades-1000`} />}
          onClick={onRefresh}
          data-testid="internal-users-refresh-button"
        >
          Refresh
        </Button>
        {canManage ? (
          <Button
            size="small"
            color="dark"
            leftIcon={<GSIcon iconName="gs_plus_medium" size={20} css={tw`text-shades-0`} />}
            onClick={onInviteClick}
            data-testid="internal-users-invite-button"
          >
            Add user
          </Button>
        ) : null}
      </div>
    </div>
  )
}

export const InternalUsersToolbar = memo(InternalUsersToolbarComponent)
